module.exports = __webpack_public_path__ + "images/7f9a0fc023807c0cf21701f32eada584.svg";